import GA from 'utils/googleAnalytics';
import { isProduction } from 'utils/environment';

let ga;

async function initGA(G, user_id) {
  if (!GA.isInitialized() && G && isProduction) {
    let config = {
      linker: {
        domains: ['fundlocal.ie', 'hailopay.ie', 'admin.javelinhq.com'],
      },
    };
    if (user_id) {
      config.user_id = user_id;
    }
    ga = new GA(G, config);

    try {
      ga.initialize();
    } catch (error) {
      console.error(error);
    }
  }
}

export function logEvent(
  action,
  { label, category, non_interaction, ...params } = {}
) {
  if (ga) ga.event(action, { label, category, non_interaction, ...params });
}

export default initGA;

export function logCtaWithLabel(label) {
  if (ga) {
    logEvent('click', {
      category: 'cta',
      label,
    });
  }
}
export function logClickFundraiser(fundraiserCount) {
  if (ga) {
    logCtaWithLabel(
      fundraiserCount ? 'create_fundraiser' : 'create_first_fundraiser'
    );
  }
}
export function logActionRequired() {
  if (ga) {
    logCtaWithLabel('action_required');
  }
}
